import { h } from "preact";
import { t, translate } from "../../I18n";
import FulfillmentTimeForm from "../../components/FulfillmentTimeForm";
import PreactModal from "../../components/PreactModal";
import { observer } from "mobx-react";
function FulfillmentTimeModal(props) {
    const { isOpen, fulfillmentTime, controller, openingHour, onShown, onHidden, } = props;
    return (h(PreactModal, { id: "fulfillment-time", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h("div", { class: "modal-header" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "close", "aria-label": translate(t.generic.close) },
                h("span", { "aria-hidden": "true", class: "icon-cancel" })),
            h("h4", { class: "modal-title" }, translate(t.orders.form.fulfillment_options))),
        h("div", { class: "modal-body" },
            h(FulfillmentTimeForm, { fulfillmentTime: fulfillmentTime, controller: controller, openingHour: openingHour })),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "btn btn-primary btn-block" }, translate(t.actions.save)))));
}
export default observer(FulfillmentTimeModal);
